<section>
    <h1>Readme</h1>
    <i>Welcome to my portfolio website!</i>
    <p>
        It is still under construction, so your patience is appreciated. My
        motivation for creating this website was to avoid using pretty,
        ready-to-use templates, and instead put an emphasis on the content in a
        creative way. I also made the website mostly from scratch with minimal
        dependencies
    </p>
    <ol>
        <li>
            to demonstrate that I like to build things and tinker with them, and
        </li>
        <li>
            because I don't get to do enough front-end as a Robotics Software
            Engineer.
        </li>
    </ol>
    <p>
        You may notice (<i>appreciate?</i>) that the website resembles a
        desktop. You may also observe (<i>mock?</i>) the various kinks and
        issues that I have yet to resolve. Rest assured, that your continued
        patience and persistence will be rewarded with new features and content.
        If you would like a sneak peek at what's to come, please see the
        <code>TODO.txt</code> list.
    </p>

    <p>A few helpful pointers :-</p>
    <ul>
        <li>Icons require double clicks to open.</li>
        <li>
            The windows are draggable and resize-able (bottom-right corner).
        </li>
        <li>
            If you find that you cannot scroll on a window, you may need to
            click inside it. This will be resolved in the future.
        </li>
        <li>
            The <code>.exe</code> files are actual projects I've made (or condensed
            into simple websites)!
        </li>
        <ul>
            <li>
                <code>rock-the-boat</code> is a simulation where you can draw your own boat
                and simulate it's buoyancy...
            </li>
            <li>
                <code>das-pan</code> has an interactive robot you can drive around, you'll
                just need to scroll down for it. controls are defined as well
            </li>
            <li>
                <code>akara</code> is a demonstration of my capstone project on automated
                fitness tracking
            </li>
            <li>
                <code>lil-hearts</code> is a co-op project for BC children's hospital to
                visualize and interact with heart models
            </li>
        </ul>
        <li>
            Optimizing for small screens is in the works. Until then please try
            landscape mode...
        </li>
    </ul>
</section>

<style>
    section {
        padding: 20px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans",
            Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
        background-color: #fefefe;
        color: #010101;
    }
</style>
